import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Components
import { SpinnerComponent } from './spinner.component';
// services
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
    imports: [
        CommonModule,
        MatProgressBarModule
    ],
    declarations: [
        SpinnerComponent
    ],
    exports: [
        SpinnerComponent
    ],
    providers: []
})
export class SpinnerModule { }
